import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=7d7a7c98&scoped=true"
import script from "./doctor.vue?vue&type=script&lang=js"
export * from "./doctor.vue?vue&type=script&lang=js"
import style0 from "./doctor.vue?vue&type=style&index=0&id=7d7a7c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7a7c98",
  null
  
)

export default component.exports